export default "__VITE_ASSET__DKSqYNPQ__"